{
  "about.blocks": "Mga pinatimping server",
  "about.contact": "Kontak:",
  "about.default_locale": "Default",
  "about.disclaimer": "Ang Mastodon ay software na malaya at bukas-na-pinagmulan, at isang tatak-pangkalakal ng Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "Hindi makuha ang dahilan",
  "about.domain_blocks.preamble": "Sa kadalasan, hinahayaan ka ng Mastodon na makita ang mga content sa, at makipag-interact sa users ng, ibang servers sa fediverse. Narito ang exceptions na ginawa sa partikular na server na ito.",
  "about.domain_blocks.silenced.explanation": "Sa kadalasan, hindi mo makikita ang profiles at content mula sa server na ito, maliban na lang kung sasadyain mo silang hanapin o piliing magawa ito sa pamamagitan ng mga sumusunod.",
  "about.domain_blocks.silenced.title": "Limitado",
  "about.domain_blocks.suspended.explanation": "Walang data mula sa server na ito ang mapoproseso, maiimbak o maipagpapaplitan. Sa gayon. imposibleng magawa ang interaksiyon o komunikasyon sa ibang users sa server na ito.",
  "about.domain_blocks.suspended.title": "Suspendido",
  "about.language_label": "Wika",
  "about.not_available": "Hindi available ang impormasyong ito.",
  "about.powered_by": "Decentralisadong social media na pinapagana ng {mastodon}",
  "about.rules": "Mga alituntunin ng server",
  "account.account_note_header": "Note na personal",
  "account.add_or_remove_from_list": "I-dagdag o tanggalin mula sa mga listahan",
  "account.badges.bot": "Pakusa",
  "account.badges.group": "Pangkat",
  "account.block": "Hadlangan si @{name}",
  "account.block_domain": "Hadlangan ang domain na {domain}",
  "account.block_short": "Hadlangan",
  "account.blocked": "Hinadlangan",
  "account.cancel_follow_request": "I-kansela ang pagsunod",
  "account.copy": "I-sipi ang kawing sa profile",
  "account.direct": "Palihim banggitin si @{name}",
  "account.disable_notifications": "I-tigil ang pagpapaalam sa akin tuwing nagpopost si @{name}",
  "account.edit_profile": "Baguhin ang profile",
  "account.edit_profile_short": "I-edit",
  "account.enable_notifications": "Ipaalam sa akin kapag nag-post si @{name}",
  "account.endorse": "I-tampok sa profile",
  "account.familiar_followers_many": "Sinusundan nina {name1}, {name2}, at {othersCount, plural, one {# iba pa na kilala mo} other {# na iba pa na kilala mo}}",
  "account.familiar_followers_one": "Sinusindan ni/ng {name1}",
  "account.familiar_followers_two": "Sinusindan nina {name1} at {name2}",
  "account.featured": "Itinatampok",
  "account.featured.accounts": "Mga Profile",
  "account.follow": "Sundan",
  "account.follow_back": "Sundan pabalik",
  "account.follow_back_short": "I-follow back",
  "account.follow_request": "Humiling na mag-follow",
  "account.follow_request_cancel": "I-cancel ang request",
  "account.follow_request_cancel_short": "Cancel",
  "account.follow_request_short": "Request",
  "account.followers": "Mga tagasunod",
  "account.followers.empty": "Wala pang sumusunod sa tagagamit na ito.",
  "account.followers_counter": "{count, plural, one {{counter} tagasunod} other {{counter} tagasunod}}",
  "account.followers_you_know_counter": "{counter} (na) kilala mo",
  "account.following": "Sinusundan",
  "account.following_counter": "{count, plural, one {{counter} sinusundan} other {{counter} sinusundan}}",
  "account.follows.empty": "Wala pang sinusundan ang tagagamit na ito.",
  "account.follows_you": "Sinusundan ka",
  "account.go_to_profile": "Pumunta sa profile",
  "account.hide_reblogs": "Itago ang mga pagpapalakas mula sa {name}",
  "account.in_memoriam": "Sa Alaala Ni.",
  "account.joined_short": "Sumali",
  "account.languages": "Palitan ang mga nakasumuscribing wika",
  "account.link_verified_on": "Sinuri ang pagmamay-ari ng kawing ito sa {date}",
  "account.locked_info": "Nakakandado ang pagsasariling kalagayan ng account na ito. Manomano sinusuri ng may-ari kung sino ang maaaring sumunod sa kanya.",
  "account.media": "Medya",
  "account.mention": "Banggitin si @{name}",
  "account.moved_to": "Ipinahihiwatig ni {name} na ang kanilang bagong account ngayon ay:",
  "account.mute": "I-mute si @{name}",
  "account.mute_notifications_short": "I-mute ang mga abiso",
  "account.mute_short": "I-mute",
  "account.muted": "Naka-mute",
  "account.mutual": "Pina-follow nyo ang isa't-isa",
  "account.no_bio": "Walang nakalaan na paglalarawan.",
  "account.open_original_page": "Buksan ang pinagmulang pahina",
  "account.posts": "Mga post",
  "account.remove_from_followers": "Alisin si {name} sa mga follower",
  "account.report": "I-ulat si/ang @{name}",
  "account.requested_follow": "Hinihiling ni {name} na sundan ka",
  "account.share": "Ibahagi ang profile ni @{name}",
  "account.show_reblogs": "Ipakita ang mga pagpapalakas mula sa/kay {name}",
  "account.statuses_counter": "{count,plural,one {{counter} i-post} other {{counter} mga post}}",
  "account.unblock": "I-unblock si @{name}",
  "account.unblock_domain": "I-unblock ang domain {domain}",
  "account.unblock_domain_short": "I-unblock",
  "account.unblock_short": "I-unblock",
  "account.unendorse": "Huwag itampok sa profile",
  "account.unfollow": "Huwag nang sundan",
  "account.unmute": "I-unmute si @{name}",
  "account.unmute_notifications_short": "I-unmute ang mga notification",
  "account.unmute_short": "I-unmute",
  "account_note.placeholder": "I-click para magdagdag ng note",
  "admin.dashboard.retention.cohort_size": "Mga bagong tagagamit",
  "alert.rate_limited.message": "Mangyaring subukan muli pagkatapos ng {retry_time, time, medium}.",
  "audio.hide": "Itago ang tunog",
  "block_modal.show_less": "Magpakita ng mas kaunti",
  "block_modal.show_more": "Magpakita ng higit pa",
  "block_modal.they_will_know": "Makita nila na hinarangan sila.",
  "block_modal.title": "Harangan ang tagagamit?",
  "boost_modal.combo": "Maari mong pindutin ang {combo} upang laktawan ito sa susunod na oras",
  "bundle_column_error.error.title": "Naku!",
  "bundle_column_error.network.body": "Nagkaroon ng kamalian habang sinusubukang i-karga ang pahinang ito. Maaaring dahil ito sa pansamantalang problema ng iyong koneksyon sa internet o ang server na ito.",
  "bundle_column_error.network.title": "Kamaliang network",
  "bundle_column_error.retry": "Subukang muli",
  "bundle_column_error.return": "Bumalik sa tahanan",
  "bundle_column_error.routing.body": "Hindi mahanap ang hiniling na pahina. Sigurado ka ba na ang URL sa address bar ay tama?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "I-sara",
  "bundle_modal_error.retry": "Subukang muli",
  "closed_registrations.other_server_instructions": "Dahil desentralisado ang Mastodon, pwede kang gumawa ng account sa iba pang server at makipag-ugnayan pa rin dito.",
  "closed_registrations_modal.description": "Hindi pa pwedeng gumawa ng account sa {domain}, pero tandaan na hindi mo kailangan ng account partikular sa {domain} para gamitin ang Mastodon.",
  "closed_registrations_modal.find_another_server": "Maghanap ng iba pang server",
  "closed_registrations_modal.preamble": "Dahil desentralisado ang Mastodon, kahit saan ka pa gumawa ng account, maaari ka pa ring sumunod at makipag-ugnayan sa kahit-sino rito sa server na ito. Pwede mo pang i-host nang pasarili!",
  "closed_registrations_modal.title": "Pagrerehistro sa Mastodon",
  "column.about": "Tungkol dito",
  "column.blocks": "Nakahadlang na mga tagagamit",
  "column.bookmarks": "Mga bookmark",
  "column.community": "Lokal na timeline",
  "column.direct": "Mga palihim na banggit",
  "column.directory": "Tingnan ang mga profile",
  "column.domain_blocks": "Nakahadlang na mga domain",
  "column.favourites": "Mga paborito",
  "column.firehose": "Mga live feed",
  "column.follow_requests": "Mga hiling para sundan",
  "column.home": "Tahanan",
  "column.lists": "Mga listahan",
  "column.mutes": "Mga pinatahimik na tagagamit",
  "column.notifications": "Mga abiso",
  "column.pins": "Mga nakapaskil na post",
  "column.public": "Pinagsamang timeline",
  "column_back_button.label": "Bumalik",
  "column_header.hide_settings": "I-tago ang mga setting",
  "column_header.moveLeft_settings": "I-lipat ang hanay pakaliwa",
  "column_header.moveRight_settings": "I-lipat ang hanay pakanan",
  "column_header.pin": "I-paskil",
  "column_header.show_settings": "Ipakita ang mga setting",
  "column_header.unpin": "Tanggalin sa pagkapaskil",
  "community.column_settings.local_only": "Lokal lamang",
  "community.column_settings.media_only": "Medya Lamang",
  "community.column_settings.remote_only": "Liblib lamang",
  "compose.language.change": "Magpalit ng wika",
  "compose.language.search": "Maghanap ng mga wika...",
  "compose.published.body": "Nailathala ang post.",
  "compose.published.open": "Buksan",
  "compose.saved.body": "Nai-save ang post.",
  "compose_form.direct_message_warning_learn_more": "Matuto pa",
  "compose_form.encryption_warning": "Ang mga post sa Mastodon ay hindi naka-encrypt nang dulo-dulo. Huwag magbahagi ng anumang sensitibong impormasyon sa Mastodon.",
  "compose_form.hashtag_warning": "Hindi maililista ang post na ito sa anumang hashtag dahil hindi ito nakapubliko. Mga nakapublikong post lamang ang mahahanap ayon sa hashtag.",
  "compose_form.lock_disclaimer": "Hindi {locked} ang iyong account. Maaaring susundan ka ng sinuman upang tingnan ang iyong mga post na para sa mga tagasunod lamang.",
  "compose_form.lock_disclaimer.lock": "nakakandado",
  "compose_form.placeholder": "Anong nangyari?",
  "compose_form.poll.duration": "Tagal ng botohan",
  "compose_form.poll.multiple": "Maraming pagpipilian",
  "compose_form.reply": "Tumugon",
  "compose_form.spoiler.marked": "Tanggalin ang babala sa nilalaman",
  "compose_form.spoiler.unmarked": "Idagdag ang babala sa nilalaman",
  "compose_form.spoiler_placeholder": "Babala sa nilalaman (hindi kinailangan)",
  "confirmation_modal.cancel": "Pagpaliban",
  "confirmations.block.confirm": "Harangan",
  "confirmations.delete.message": "Sigurado ka bang gusto mong burahin ang post na ito?",
  "confirmations.delete_list.confirm": "Tanggalin",
  "confirmations.delete_list.message": "Sigurado ka bang gusto mong burahin ang listahang ito?",
  "confirmations.discard_edit_media.confirm": "Ipagpaliban",
  "content_warning.hide": "Itago ang post",
  "content_warning.show_more": "Magpakita ng higit pa",
  "conversation.mark_as_read": "Markahan bilang nabasa na",
  "conversation.open": "Tingnan ang pag-uusap",
  "copy_icon_button.copied": "Sinipi sa clipboard",
  "copypaste.copied": "Sinipi",
  "copypaste.copy_to_clipboard": "I-sipi sa clipboard",
  "directory.federated": "Mula sa kilalang fediverse",
  "directory.local": "Mula sa {domain} lamang",
  "directory.new_arrivals": "Mga bagong dating",
  "directory.recently_active": "Kamakailang aktibo",
  "disabled_account_banner.account_settings": "Mga setting ng account",
  "disabled_account_banner.text": "Ang iyong account na {disabledAccount} ay hindi pinapagana ngayon.",
  "dismissable_banner.community_timeline": "Ito ang mga pinakamakailang nakapublikong post mula sa mga taong ang mga account hinohost ng {domain}.",
  "dismissable_banner.dismiss": "Alisin",
  "domain_block_modal.block": "Harangan ang serbiro",
  "domain_block_modal.they_wont_know": "Hindi nila malalaman na hinarang sila.",
  "domain_block_modal.title": "Harangan ang domain?",
  "domain_block_modal.you_will_lose_relationships": "Mawawala ang lahat ng mga tagasunod at mga taong sinusindan mo mula sa serbirong ito.",
  "domain_block_modal.you_wont_see_posts": "Hindi mo makikita ang mga post o mga abiso mula sa mga tagagamit sa serbirong ito.",
  "domain_pill.server": "Serbiro",
  "embed.instructions": "I-embed ang post na ito sa iyong pook-sapot sa pamamagitan ng pagsipi ng kodigo sa ilalim.",
  "embed.preview": "Ito ang magiging itsura:",
  "emoji_button.activity": "Aktibidad",
  "emoji_button.clear": "Linisin",
  "emoji_button.custom": "Pasadya",
  "emoji_button.flags": "Mga watawat",
  "emoji_button.food": "Pagkain at Inumin",
  "emoji_button.label": "Maglagay ng emoji",
  "emoji_button.nature": "Kalikasan",
  "emoji_button.not_found": "Walang mahanap na mga tugmang emoji",
  "emoji_button.objects": "Mga bagay",
  "emoji_button.people": "Mga tao",
  "emoji_button.recent": "Madalas na ginagamit",
  "emoji_button.search": "Maghanap...",
  "emoji_button.search_results": "Resulta ng paghahanap",
  "emoji_button.symbols": "Mga tanda",
  "emoji_button.travel": "Paglakbay at Mga Lugar",
  "empty_column.account_hides_collections": "Pinili ng tagagamit na ito na hindi makuha ang impormasyong ito",
  "empty_column.account_suspended": "Sinuspinde ang account",
  "empty_column.account_timeline": "Walang mga post dito!",
  "empty_column.account_unavailable": "Hindi makuha ang profile",
  "empty_column.blocks": "Hindi ka pa naghahadlang ng sinumang tagagamit.",
  "empty_column.bookmarked_statuses": "Wala ka pang naka-bookmark na post. Kapag nag-bookmark ka ng isa, makikita yun dito.",
  "empty_column.community": "Walang laman ang lokal na timeline. Magsulat ng anuman papubliko para makaandar tayo!",
  "empty_column.direct": "Wala ka pang mga palihim na banggit. Kapag nagpadala o tumanggap ka ng isa, makikita yun dito.",
  "empty_column.domain_blocks": "Wala pang nakahadlang na domain.",
  "empty_column.explore_statuses": "Wala pang sumisikat sa ngayon. Balik na lang sa muli!",
  "empty_column.favourited_statuses": "Wala ka pang mga paboritong post. Kapag nag-paborito ka ng isa, makikita yun dito.",
  "empty_column.favourites": "Wala pang may paborito ng post na ito. Kung may sinumang nagpaborito, makikita sila rito.",
  "empty_column.follow_requests": "Wala ka pang mga hiling para sundan ka. Kapag nakatanggap ka ng isa, makikita yun dito.",
  "empty_column.followed_tags": "Wala ka pang sinusunod na hashtag. Kapag may sinundan ka na, makikita sila rito.",
  "empty_column.hashtag": "Wala pang laman ang hashtag na ito.",
  "empty_column.home": "Walang laman ang timeline ng tahanan mo! Sumunod sa marami pang tao para mapunan ito.",
  "empty_column.list": "Wala pang laman ang listahang ito. Kapag naglathala ng mga bagong post ang mga miyembro ng listahang ito, makikita iyon dito.",
  "empty_column.notification_requests": "Malinis na lahat! Walang anuman dito. Kapag nakatanggap ka ng mga bagong abiso, makikita sila dito na batay sa iyong mga setting.",
  "errors.unexpected_crash.report_issue": "Iulat ang isyu",
  "explore.suggested_follows": "Mga tao",
  "explore.trending_links": "Mga balita",
  "filter_modal.select_filter.search": "Hanapin o gumawa",
  "filter_warning.matches_filter": "Tinutugma ang pangsala \"<span>{title}</span>\"",
  "firehose.all": "Lahat",
  "firehose.local": "Itong serbiro",
  "firehose.remote": "Ibang mga serbiro",
  "follow_request.authorize": "Tanggapin",
  "follow_request.reject": "Tanggihan",
  "follow_suggestions.dismiss": "Huwag nang ipakita muli",
  "follow_suggestions.popular_suggestion": "Sikat na mungkahi",
  "follow_suggestions.popular_suggestion_longer": "Sikat sa {domain}",
  "follow_suggestions.view_all": "Tingnan lahat",
  "follow_suggestions.who_to_follow": "Sinong maaaring sundan",
  "footer.about": "Tungkol dito",
  "footer.get_app": "Kunin ang app",
  "footer.status": "Katayuan",
  "generic.saved": "Nakaimbak",
  "hashtag.column_header.tag_mode.all": "at {additional}",
  "hashtag.column_header.tag_mode.any": "o {additional}",
  "hashtag.column_settings.select.no_options_message": "Walang mungkahing nakita",
  "hashtag.column_settings.tag_mode.all": "Lahat ng nandito",
  "hashtag.column_settings.tag_mode.any": "Ilan dito",
  "hashtag.column_settings.tag_mode.none": "Wala dito",
  "hashtags.and_other": "…at {count, plural, one {# iba pa} other {# na iba pa}}",
  "home.column_settings.show_replies": "Ipakita ang mga tugon",
  "home.pending_critical_update.body": "Mangyaring i-update ang iyong serbiro ng Mastodon sa lalong madaling panahon!",
  "interaction_modal.on_another_server": "Sa ibang serbiro",
  "interaction_modal.on_this_server": "Sa serbirong ito",
  "intervals.full.days": "{number, plural, one {# araw} other {# na araw}}",
  "intervals.full.hours": "{number, plural, one {# oras} other {# na oras}}",
  "intervals.full.minutes": "{number, plural, one {# minuto} other {# na minuto}}",
  "keyboard_shortcuts.blocked": "Buksan ang talaan ng mga nakaharang na mga tagagamit",
  "keyboard_shortcuts.description": "Paglalarawan",
  "keyboard_shortcuts.down": "Ilipat pababa sa talaan",
  "keyboard_shortcuts.mention": "Banggitin ang may-akda",
  "keyboard_shortcuts.requests": "Buksan ang talaan ng mga kahilingan sa pagsunod",
  "keyboard_shortcuts.up": "Ilipat pataas sa talaan",
  "lightbox.close": "Isara",
  "lightbox.next": "Susunod",
  "lightbox.previous": "Nakaraan",
  "link_preview.author": "Ni/ng {name}",
  "lists.delete": "Burahin ang listahan",
  "lists.replies_policy.none": "Walang simuman",
  "loading_indicator.label": "Kumakarga…",
  "media_gallery.hide": "Itago",
  "mute_modal.hide_from_notifications": "Itago mula sa mga abiso",
  "navigation_bar.about": "Tungkol dito",
  "navigation_bar.blocks": "Nakaharang na mga tagagamit",
  "navigation_bar.direct": "Mga palihim na banggit",
  "navigation_bar.favourites": "Mga paborito",
  "navigation_bar.follow_requests": "Mga hiling sa pagsunod",
  "navigation_bar.follows_and_followers": "Mga sinusundan at tagasunod",
  "navigation_bar.lists": "Mga listahan",
  "navigation_bar.search": "Maghanap",
  "notification.admin.report": "Iniulat ni {name} si {target}",
  "notification.admin.report_statuses_other": "Iniulat ni {name} si {target}",
  "notification.follow": "Sinundan ka ni {name}",
  "notification.follow.name_and_others": "Sinundan ka ng/nina {name} at <a>{count,  plural, one {# iba pa} other {# na iba pa}}</a>",
  "notification.follow_request": "Hinihiling ni {name} na sundan ka",
  "notification.label.private_mention": "Palihim na banggit",
  "notification.mentioned_you": "Binanggit ka ni {name}",
  "notification.moderation-warning.learn_more": "Matuto nang higit pa",
  "notification.moderation_warning": "Mayroong kang natanggap na babala sa pagtitimpi",
  "notification.reblog": "Pinalakas ang iyong post ni {name}",
  "notification.reblog.name_and_others_with_link": "Pinalakas ang iyong post ni/ng {name} at <a>{count, plural,one {# iba pa} other {# na iba pa}}</a>",
  "notification.relationships_severance_event.learn_more": "Matuto nang higit pa",
  "notification_requests.accept": "Tanggapin",
  "notification_requests.maximize": "Palakihin",
  "notification_requests.notifications_from": "Mga abiso mula kay/sa {name}",
  "notifications.clear": "Burahin mga abiso",
  "notifications.clear_title": "Linisin ang mga abiso?",
  "notifications.column_settings.admin.report": "Mga bagong ulat:",
  "notifications.column_settings.alert": "Mga abiso sa Desktop",
  "notifications.column_settings.favourite": "Mga paborito:",
  "notifications.column_settings.follow": "Mga bagong tagasunod:",
  "notifications.column_settings.group": "Pangkat",
  "notifications.column_settings.poll": "Resulta ng botohan:",
  "notifications.column_settings.unread_notifications.category": "Hindi Nabasang mga Abiso",
  "notifications.column_settings.update": "Mga pagbago:",
  "notifications.filter.all": "Lahat",
  "notifications.filter.boosts": "Mga pagpalakas",
  "notifications.filter.favourites": "Mga paborito",
  "notifications.filter.follows": "Mga sinusundan",
  "notifications.filter.mentions": "Mga pagbanggit",
  "notifications.filter.polls": "Resulta ng botohan",
  "notifications.mark_as_read": "Markahan lahat ng abiso bilang nabasa na",
  "notifications.policy.accept": "Tanggapin",
  "notifications.policy.accept_hint": "Ipakita sa mga abiso",
  "notifications.policy.filter_not_followers_title": "Mga taong hindi ka susundan",
  "notifications.policy.filter_not_following_title": "Mga taong hindi mo sinusundan",
  "onboarding.profile.note_hint": "Maaari mong @bangitin ang ibang mga tao o mga #hashtag…",
  "picture_in_picture.restore": "Ilagay ito pabalik",
  "poll.closed": "Sarado",
  "poll.reveal": "Ipakita ang mga resulta",
  "poll.voted": "Binoto mo para sa sagot na ito",
  "poll_button.remove_poll": "Tanggalin ang boto",
  "privacy.direct.long": "Lahat ng mga binanggit sa post",
  "privacy.private.long": "Mga tagasunod mo lamang",
  "privacy.private.short": "Mga tagasunod",
  "privacy.public.long": "Sinumang nasa loob at labas ng Mastodon",
  "privacy.public.short": "Pampubliko",
  "privacy.unlisted.short": "Hindi nakalista",
  "privacy_policy.last_updated": "Huling nabago noong {date}",
  "recommended": "Inirekomenda",
  "relative_time.days": "{number}a",
  "relative_time.full.days": "{number, plural, one {# araw} other {# na araw}} ang nakalipas",
  "relative_time.full.hours": "{number, plural, one {# oras} other {# na oras}} ang nakalipas",
  "relative_time.full.just_now": "ngayon lang",
  "relative_time.full.minutes": "{number, plural, one {# minuto} other {# na minuto}} ang nakalipas",
  "relative_time.full.seconds": "{number, plural, one {# segundo} other {# na segundo}} ang nakalipas",
  "relative_time.hours": "{number}o",
  "relative_time.just_now": "ngayon",
  "relative_time.minutes": "{number}m",
  "relative_time.seconds": "{number}s",
  "relative_time.today": "ngayon",
  "reply_indicator.cancel": "Ipagpaliban",
  "report.block": "Harangan",
  "report.categories.other": "Iba pa",
  "report.categories.violation": "Lumalabag ang nilalaman sa isa o higit pang mga patakaran ng serbiro",
  "report.category.subtitle": "Piliin ang pinakamahusay na tugma",
  "report.category.title": "Sabihin mo sa amin kung anong nangyari sa {type} na ito",
  "report.close": "Tapos na",
  "report.comment.title": "Mayroon pa bang dapat naming malaman?",
  "report.next": "Sunod",
  "report.placeholder": "Mga Karagdagang Puna",
  "report.reasons.dislike": "Hindi ko gusto ito",
  "report.reasons.legal": "Labag ito sa batas",
  "report.reasons.violation": "Lumalabag ito sa mga panuntunan ng serbiro",
  "report.reasons.violation_description": "Alam mo na lumalabag ito sa mga partikular na panuntunan",
  "report.rules.title": "Aling mga patakaran ang nilabag?",
  "report.submit": "Isumite",
  "report.target": "Iniulat si/ang {target}",
  "report.thanks.take_action_actionable": "Habang sinusuri namin ito, maaari kang gumawa ng aksyon laban kay/sa {name}:",
  "report.thanks.title": "Ayaw mo bang makita ito?",
  "report.thanks.title_actionable": "Salamat sa pag-uulat, titingnan namin ito.",
  "report_notification.categories.other": "Iba pa",
  "report_notification.categories.other_sentence": "iba pa",
  "report_notification.categories.violation": "Paglabag sa patakaran",
  "report_notification.categories.violation_sentence": "paglabag sa patakaran",
  "report_notification.open": "Buksan ang ulat",
  "search.placeholder": "Maghanap",
  "search.quick_action.go_to_account": "Pumunta sa profile {x}",
  "search.quick_action.open_url": "Buksan ang URL sa Mastodon",
  "search.search_or_paste": "Maghanap o ilagay ang URL",
  "search_popout.full_text_search_disabled_message": "Hindi magagamit sa {domain}.",
  "search_popout.full_text_search_logged_out_message": "Magagamit lamang kapag naka-log in.",
  "search_popout.recent": "Kamakailang mga paghahanap",
  "search_results.all": "Lahat",
  "search_results.see_all": "Ipakita lahat",
  "server_banner.server_stats": "Katayuan ng serbiro:",
  "status.block": "Harangan si @{name}",
  "status.cannot_reblog": "Hindi maaring mapalakas ang post na ito",
  "status.delete": "Tanggalin",
  "status.direct": "Palihim na banggitin si/ang @{name}",
  "status.direct_indicator": "Palihim na banggit",
  "status.edit": "Baguhin",
  "status.edited_x_times": "Binago {count, plural, one {{count} beses} other {{count} na beses}}",
  "status.history.created": "Nilikha ni/ng {name} {date}",
  "status.history.edited": "Binago ni/ng {name} {date}",
  "status.media.open": "Pindutin upang buksan",
  "status.media.show": "Pindutin upang ipakita",
  "status.mention": "Banggitin ang/si @{name}",
  "status.more": "Higit pa",
  "status.read_more": "Basahin ang higit pa",
  "status.reblogged_by": "Pinapalakas ni/ng {name}",
  "status.reblogs.empty": "Wala pang nagpalakas ng post na ito. Kung may sinumang nagpalakas, makikita sila rito.",
  "status.remove_favourite": "Tanggalin sa mga paborito",
  "status.reply": "Tumugon",
  "status.report": "I-ulat si/ang @{name}",
  "status.sensitive_warning": "Sensitibong nilalaman",
  "status.share": "Ibahagi",
  "status.show_less_all": "Magpakita ng mas kaunti para sa lahat",
  "status.show_more_all": "Magpakita ng higit pa para sa lahat",
  "status.translate": "Isalin",
  "status.translated_from_with": "Isalin mula sa {lang} gamit ang {provider}",
  "status.uncached_media_warning": "Hindi makuha ang paunang tigin",
  "tabs_bar.notifications": "Mga abiso",
  "time_remaining.days": "{number, plural, one {# araw} other {# na araw}} ang natitira",
  "time_remaining.hours": "{number, plural, one {# oras} other {# na oras}} ang natitira",
  "time_remaining.minutes": "{number, plural, one {# minuto} other {# na minuto}} ang natitira",
  "time_remaining.seconds": "{number, plural, one {# segundo} other {# na segundo}} ang natitira"
}
